export const name = "ST_CLOSESTPOINT";
export const summary = `Gets the point on a \`GEOGRAPHY\` value which is closest to any point in a second \`GEOGRAPHY\` value.`;
export const reference = `
## ST_CLOSESTPOINT

Gets the point on a \`GEOGRAPHY\` value which is closest to any point in a second \`GEOGRAPHY\` value.

\`\`\`
ST_CLOSESTPOINT(geography_1, geography_2[, use_spheroid])
\`\`\`

### Description

Returns a \`GEOGRAPHY\` containing a point on\`geography_1\` with the smallest possible distance to \`geography_2\`. This implies that the distance between the point returned by \`ST_CLOSESTPOINT\` and\`geography_2\` is less than or equal to the distance between any other point on\`geography_1\` and \`geography_2\`.

If either of the input \`GEOGRAPHY\`s is empty, \`ST_CLOSESTPOINT\` returns \`NULL\`.

The optional \`use_spheroid\` parameter determines how this function measures distance. If \`use_spheroid\` is \`FALSE\`, the function measures distance on the surface of a perfect sphere.

The \`use_spheroid\` parameter currently only supports the value \`FALSE\`. The default value of \`use_spheroid\` is \`FALSE\`.


### Return type

Point \`GEOGRAPHY\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
